




























import Enumerable from "linq";
import { User } from "../../../domain/user";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { VisitHistoryInformation } from "../../../domain/his";
import { DialogMixin } from "../../system/mixins";
import VisitHistorySelector from "../selectors/VisitHistorySelector.vue";
import { Department } from "../../../domain/department";
import { VisitHistorySelectorResult } from "../../../domain/workflow/editor/selectors";

@Component({
  components: {
    VisitHistorySelector,
  },
})
export default class VisitHistorySelectorDialog extends Mixins(DialogMixin) {
  @Prop()
  visitHistories: VisitHistoryInformation[];

  @Prop()
  allValidUsers: User[];

  @Prop()
  allDepartments: Department[];

  $refs!: {
    selector: VisitHistorySelector,
  };

  data(): any {
    return {
      selectedVisitHisotry: null,
      result: null,
    };
  }
  selectedVisitHisotry: VisitHistoryInformation;
  result: VisitHistorySelectorResult;

  get hasSelected(): boolean {
    return !!this.selectedVisitHisotry;
  }

  onHistorySelectionChanged(value: VisitHistoryInformation): void {
    this.selectedVisitHisotry = value;
  }

  async show(): Promise<VisitHistorySelectorResult> {
    if (!this.visitHistories || this.visitHistories.length === 0) {
      return null;
    }

    return this.showModal(async () => {
      this.selectedVisitHisotry = null;
      this.result = null;
      if (this.$refs.selector) {
        this.$refs.selector.clearSelected();
      }
      await this.waitHidden(true);
      return this.result;
    });
  }

  cancel(): void {
    this.selectedVisitHisotry = null;
    this.close();
  }

  select(overwriteUser: boolean): void {
    const selected = this.selectedVisitHisotry.clone();
    selected.doctor = this.getSelectedValidUsers();
    selected.department = this.getSelectedValidDepartment();
    this.result = {
      visitHisotry: selected,
      overwriteUser: overwriteUser,
    };
    this.close();
  }

  private getSelectedValidUsers(): User {
    if (!this.selectedVisitHisotry.doctor) { return null; }

    const user = Enumerable.from(this.allValidUsers).firstOrDefault(u => u.id === this.selectedVisitHisotry.doctor.id);
    if (!user) {
      this.$warn("来院歴選択", "既に存在しない医師が選択されました。存在する医師と診療科のみ反映します。");
    }
    return user;
  }

  private getSelectedValidDepartment(): Department {
    return !this.selectedVisitHisotry.department
      ? null
      : Enumerable.from(this.allDepartments).firstOrDefault(d => d.id === this.selectedVisitHisotry.department.id);
  }

  private close(): void {
    this.isVisible = false;
  }
}
